import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import EFChecked from '@/components/UI/svg/blade/calculator/EFChecked';
import { BladeCal } from '@/constants/blade';

export default function Step1({ calObj, callBack }: any) {
    const { useLang, useState, gtm } = useGlobal();
    const { t } = useLang('bladecalculator');
    const [checked, setChecked] = useState(calObj?.check1 || 0);
    const LAWN_SIZE_ARR: any = [
        {
            img: (
                <NextImage
                    webpSrc={require('@publicLocal/blade/calculator/pc/cal_step1_1.webp')}
                    src={require('@publicLocal/blade/calculator/pc/cal_step1_1.png')}
                    alt={t('detail.calculator_step1_text1')}
                    aria-label={t('detail.calculator_step1_text1')}
                />
            ),
            text: t('detail.calculator_step1_text1'),
        },
        {
            img: (
                <NextImage
                    webpSrc={require('@publicLocal/blade/calculator/pc/cal_step1_2.webp')}
                    src={require('@publicLocal/blade/calculator/pc/cal_step1_2.png')}
                    alt={t('detail.calculator_step1_text2')}
                    aria-label={t('detail.calculator_step1_text2')}
                />
            ),
            text: t('detail.calculator_step1_text2'),
        },
        {
            img: (
                <NextImage
                    webpSrc={require('@publicLocal/blade/calculator/pc/cal_step1_3.webp')}
                    src={require('@publicLocal/blade/calculator/pc/cal_step1_3.png')}
                    alt={t('detail.calculator_step1_text3')}
                    aria-label={t('detail.calculator_step1_text3')}
                />
            ),
            text: t('detail.calculator_step1_text3'),
        },
        {
            img: (
                <NextImage
                    webpSrc={require('@publicLocal/blade/calculator/pc/cal_step1_4.webp')}
                    src={require('@publicLocal/blade/calculator/pc/cal_step1_4.png')}
                    alt={t('detail.calculator_step1_text4')}
                    aria-label={t('detail.calculator_step1_text4')}
                />
            ),
            text: t('detail.calculator_step1_text4'),
        },
        {
            img: (
                <NextImage
                    webpSrc={require('@publicLocal/blade/calculator/pc/cal_step1_5.webp')}
                    src={require('@publicLocal/blade/calculator/pc/cal_step1_5.png')}
                    alt={t('detail.calculator_step1_text5')}
                    aria-label={t('detail.calculator_step1_text5')}
                />
            ),
            text: t('detail.calculator_step1_text5'),
        },
    ];
    const handleCheck = (n: number) => {
        setChecked(n + 1);
        callBack({ ...calObj, currentStep: 1, check1: n + 1 });
    };
    const handleNext = () => {
        // if (checked === 1) {
        callBack({ ...calObj, currentPage: BladeCal.Step2 });
        // } else {
        //     callBack({ ...calObj, currentPage: BladeCal.Step5 });
        // }
        gtm.push({
            event: 'uaEvent',
            event_name: 'checklist_process1',
            step: 'Lawn size',
            product_name: 'EcoFlow BLADE',
            button_name: 'Next',
            option_name: LAWN_SIZE_ARR[checked ? checked - 1 : checked]?.text,
        });
    };
    return (
        <div className={`step1 ${css.step1}`}>
            <p className="step1-title">{t('detail.calculator_step1_title')}</p>
            <ul className="step1-box">
                {LAWN_SIZE_ARR?.map((lawn: any, k: number) => (
                    <li className="step1-item" key={lawn?.text} onClick={() => handleCheck(k)}>
                        <div className="img-box">
                            {lawn?.img}
                            {checked === k + 1 && (
                                <>
                                    <div className="mask"></div>
                                    <EFChecked className="checked" />
                                </>
                            )}
                        </div>
                        <p className="img-text">{lawn?.text}</p>
                    </li>
                ))}
            </ul>
            <button className="next-btn" disabled={!checked} onClick={handleNext}>
                {t('detail.calculator_btn_next')}
            </button>
        </div>
    );
}
